/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListFinancialCategoriesQueryResponse, ListFinancialCategoriesPathParams, ListFinancialCategoriesQueryParams, ListFinancialCategories400, ListFinancialCategories401, ListFinancialCategories403, ListFinancialCategories404, ListFinancialCategories409, ListFinancialCategories500 } from "../../types/financialHubController/ListFinancialCategories.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListFinancialCategoriesUrl(organizationId: ListFinancialCategoriesPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/financial/categories` as const }
  return res
}

/**
 * @summary List chart of accounts
 * {@link /api/organizations/:organizationId/financial/categories}
 */
export async function listFinancialCategories(organizationId: ListFinancialCategoriesPathParams["organizationId"], params?: ListFinancialCategoriesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListFinancialCategoriesQueryResponse, ResponseErrorConfig<ListFinancialCategories400 | ListFinancialCategories401 | ListFinancialCategories403 | ListFinancialCategories404 | ListFinancialCategories409 | ListFinancialCategories500>, unknown>({ method : "GET", url : getListFinancialCategoriesUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}